"use strict";

exports.__esModule = true;
exports.default = hasClass;

function hasClass(element, className) {
  if (element.classList) return !!className && element.classList.contains(className);else return (" " + (element.className.baseVal || element.className) + " ").indexOf(" " + className + " ") !== -1;
}

module.exports = exports["default"];


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-transition-group/~/dom-helpers/class/hasClass.js
 ** module id = 1010
 ** module chunks = 0
 **/